import { formatDistance } from "date-fns";
import { ptBR } from "date-fns/locale";

export const formatElapsedTime = (date: Date): string => {
  return `Há ${formatDistance(date, new Date(), { locale: ptBR })}`;
};

export const formatDateTime = (dateTime: string): string => {
  const date = new Date(dateTime);
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();
  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");
  const seconds = String(date.getSeconds()).padStart(2, "0");

  return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
};

export const formatDate = (dateString: string): string => {
  return new Date(dateString).toLocaleDateString("pt-BR");
};
